export const isSubscriptionError = (errorCode: number | undefined, errorMessage: string | undefined): boolean => {
    return (
        errorCode === 400 &&
        !!(errorMessage?.includes('feature is not available on your') || errorMessage?.includes('Please upgrade your subscription'))
    );
};
